import React, { useContext, useState } from 'react';
import { FaThumbsDown, FaThumbsUp } from 'react-icons/fa';
import { Button, ButtonGroup } from 'reactstrap';
import agent from '../../agent';
import { isStaffType, UserContext } from '../../context/UserContext';
import { JobInternalViewType } from '../../types/services-api';

const JobPostEvaluation = (props: {
  job: JobInternalViewType;
  updateJob: (job: JobInternalViewType) => void;
}) => {
  const { user } = useContext(UserContext);

  const [errorMessage, setErrorMessage] = useState('');

  function updateOpinion(newOpinion: string) {
    agent.Jobs.updateOpinion({
      jobId: props.job.id,
      body: {
        isLike: newOpinion === 'LIKED' && !props.job.isLike,
        isDislike: newOpinion === 'DISLIKED' && !props.job.isDislike,
      },
    })
      .then((res) => {
        props.updateJob(res.data);
      })
      .catch((err) => {
        setErrorMessage(err.message);
      });
  }

  return (
    <div className="d-flex gap-4 flex-wrap">
      <ButtonGroup>
        <Button
          color={props.job.isDislike ? 'danger' : 'light'}
          outline={!props.job.isDislike}
          onClick={() => updateOpinion('DISLIKED')}
          disabled={!isStaffType(user)}
        >
          <FaThumbsDown />
        </Button>
        <Button
          color={props.job.isLike ? 'success' : 'light'}
          outline={!props.job.isLike}
          onClick={() => updateOpinion('LIKED')}
          disabled={!isStaffType(user)}
        >
          <FaThumbsUp />
        </Button>
      </ButtonGroup>
      {!!errorMessage && (
        <div className="alert alert-danger mb-0">{errorMessage}</div>
      )}
    </div>
  );
};

export default JobPostEvaluation;
